import React, { useState, useEffect } from "react";
import { colors } from "../../../../../../../themes/Colors";
import TextInputField from "../../../../../text-input-field/TextInputField";
import { MovementCard, TransferPopUp } from "./components";
import VehicleCard from "../../../vehicle-card/VehicleCard";
import BaseButtons from "../../../../../base-buttons/BaseButtons";

const KeyMovement = ({
  keyTransferPop,
  setKeyTransferPop,
  data,
  auth,
  setLoading,
  setMessage,
  setToastPop,
  setPopUpTitle,
  setRefresh,
  refresh,
}) => {
  const [currentDriverOpen, seCurrentDriverOpen] = useState(true);
  const [keyHistory, setKeyHistor] = useState(false);
  const [keyHistoryArray, setKeyHistoryArray] = useState([]);

  const getKeyHistory = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL + "/userVehicles/getKeyHistoryFprVehicle",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            vehicleId: data ? data._id : null,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setKeyHistoryArray(respnseData.vehicleHistory);
        // setToastPop(true);
      }
    } catch (err) {}
  };
  useEffect(() => {
    if (data) {
      getKeyHistory();
    }
  }, [data]);
  return (
    <div
      style={{
        width: "100%",
        // marginTop: 10,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "scroll",
        overflowX: "hidden",
      }}
    >
      <div
        style={{
          width: "100%",
          // paddingTop: 20,
          // paddingBottom: 20,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: 120,
          marginTop: 10,
        }}
      >
        <VehicleCard
          width={"100%"}
          // onManageClick={
          //   width > 899
          //     ? () => setManageVehicle(vehicle)
          //     : () => setVehicleManageView(vehicle)
          // }
          // type={type}
          licenceNr={data ? data.liscenseNumber : "loading"}
          // engineNr={vehicle.engineNumber}
          make={data ? data.make : "loading"}
          series={data ? data.series : "loading"}
          expireDate={"200 days"}
          // index={index + 1}
        />
      </div>
      <div
        style={{
          width: "100%",
          minHeight: 50,
          borderTopStyle: "solid",
          borderBottomStyle: "solid",
          marginTop: 20,
          borderColor: "#00000050",
          marginBottom: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontWeight: "bold",
          fontSize: 16,
          color: "#00000080",
        }}
      >
        KEY MOVEMENT
      </div>
      <div
        style={{
          width: "100%",

          minHeight: 40,
          marginTop: 15,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: currentDriverOpen ? colors.white : "#000000",
        }}
      >
        <BaseButtons
          onClick={() => seCurrentDriverOpen(currentDriverOpen ? false : true)}
          label={"CURRENT DRIVER"}
          backgroundColor={currentDriverOpen ? colors.white : colors.greenLight}
          color={currentDriverOpen ? colors.greenDark : colors.white}
          borderRadius={8}
          width={"90%"}
        />
      </div>
      {currentDriverOpen ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <div style={{ minHeight: 10 }} />
          <TextInputField
            mini={true}
            labelTitle={"CONTACT NAME"}
            width={"90%"}
            size={"80%"}
            readOnly={true}
          />{" "}
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"CONTACT NUMBER"}
            width={"90%"}
            size={"80%"}
            readOnly={true}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"DATE RECIEVED"}
            width={"90%"}
            size={"80%"}
            readOnly={true}
          />
          <div style={{ minHeight: 5 }} />
          <TextInputField
            mini={true}
            labelTitle={"TRANSFERRED FROM"}
            width={"90%"}
            size={"80%"}
            readOnly={true}
          />
          <div style={{ minHeight: 10 }} />
        </div>
      ) : null}
      <div
        style={{
          width: "100%",

          minHeight: 40,
          marginTop: 10,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: keyHistory ? colors.white : "#000000",
        }}
      >
        <BaseButtons
          onClick={() => setKeyHistor(keyHistory ? false : true)}
          label={" KEY MOVEMENT HISTORY"}
          backgroundColor={keyHistory ? colors.white : colors.greenLight}
          color={keyHistory ? colors.greenDark : colors.white}
          borderRadius={8}
          width={"90%"}
        />
      </div>
      {keyHistory ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {keyHistoryArray.length >= 1
            ? keyHistoryArray.map((key, index) => {
                return (
                  <div key={index} style={{ width: "100%" }}>
                    <MovementCard
                      username={key.vehicleOwnerId}
                      transferredFrom={key.transferredBy}
                      dateRecieved={key.dateRecieved}
                      contactInfo={key.vehicleDriverContactInfo}
                    />
                  </div>
                );
              })
            : null}
        </div>
      ) : null}
      <TransferPopUp
        data={data}
        display={keyTransferPop}
        setKeyTransferPop={setKeyTransferPop}
        auth={auth}
        setLoading={setLoading}
        setMessage={setMessage}
        setPopUpTitle={setPopUpTitle}
        setToastPop={setToastPop}
        setRefresh={setRefresh}
        refresh={refresh}
      />
    </div>
  );
};

export default KeyMovement;
